// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return(
        <section id="presentation" className="space-ptb">
            <div className="container-fluid w-90">
                <div className="row align-items-center">
                    <div className="col-12 col-lg mb-5 mb-lg-0">
                        <h1 className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }} />
                        <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para1') as string }} />
                        <Link to={'/chi-siamo'} className="btn btn-primary">
                            <span>{t('homePage.presentation.btnText')}</span>    
                        </Link>
                    </div>
                    <div className="col-12 col-lg-4 text-center">
                        <img className="img-fluid" src="assets/images/casaLogo.png" alt="logo" />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;